import { Link } from "react-router-dom";
import FaqAccordion from "@/components/base/FaqAccordion";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  return (
    <section id="faq" className="mx-auto max-w-content scroll-mt-24 px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="FAQ"
            title="关于这套档案，你可能想问"
            description="如果这里没有回答你的疑问，欢迎直接发邮件或在联系页面留言。"
          />
          <Link
            to="/contact"
            className="group mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm text-foreground-800 transition-colors duration-200 hover:border-accent-500 hover:text-accent-400 cursor-pointer"
          >
            <i className="ri-question-answer-line text-base" />
            还有别的问题
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </section>
  );
}